import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=d89e581a&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"
import style0 from "./Chip.vue?vue&type=style&index=0&id=d89e581a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89e581a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d89e581a')) {
      api.createRecord('d89e581a', component.options)
    } else {
      api.reload('d89e581a', component.options)
    }
    module.hot.accept("./Chip.vue?vue&type=template&id=d89e581a&scoped=true", function () {
      api.rerender('d89e581a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/MultiSelectionBadge/Chip.vue"
export default component.exports